function AttachmentVO(id, description, version, author, createDate, editDate, latestDocumentExternalId, attachmentFiles, type, name, attachmentCategory) {
    this.id = id;
    this.description = description;
    this.version = version;
    this.author = author;
    this.createDate = createDate;
    this.editDate = editDate;
    this.latestDocumentExternalId = latestDocumentExternalId;
    this.attachmentFiles = attachmentFiles;
    this.attachmentCategory = attachmentCategory;
    this.type = type;
    this.name = name;

    var _typeContext = {
        author: UserVO,
        createDate: Date,
        editDate: Date,
        attachmentFiles: AttachmentFileVO,
        attachmentCategory: DictionaryElementVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
